<h3 mat-dialog-title class="titre3 text-white">{{ 'COMMUN.CONFIRMATION' | translate }}</h3>
<mat-dialog-content>
    <p class="dark:text-white">{{ 'COMMUN.CONFIRM_EXPORT' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="flex justify-end mt-4">
    <button mat-button (click)="onCancel()"
        class="mr-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-500 rounded-md hover:bg-gray-50">
        {{ 'COMMUN.CANCEL' | translate }}
    </button>
    <button mat-button color="primary" (click)="onConfirm()"
        class="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 dark:hover:bg-red-800">
        {{ exportLabelKey | translate }}
    </button>
</mat-dialog-actions>